export const environment = {
    production: true,
    apiKey: 'AIzaSyCs_pctkZuuM7pBsWU4m-E5YNBN_3oavrg',
  };
  
  
  export const environmentFire = {
    production: false,
    firebase: {
        apiKey: "AIzaSyDmp-oOKAjSQtIXOweSsyrzQPsL0wbpm1A",
        authDomain: "touchconnectapp.firebaseapp.com",
        projectId: "touchconnectapp",
        storageBucket: "touchconnectapp.firebasestorage.app",
        messagingSenderId: "215281937303",
        appId: "1:215281937303:web:032b1f0752defea507f2d2",
        measurementId: "G-HMLKTWWFSJ"
    },
  };
  
  
  export const  Monthykey:string='price_1PVcna096TMSX8WQuktlmhvf';
  export const  weeklyKey:string='price_1PW9Nt096TMSX8WQx6zOlfDp';
  
  
  export const environmentstripe = {
    stripePublishableKey: 'pk_test_51QtBGvERdWOr4gqouUk4ixMwOYLnYfXdFd0iyfqqKh1W69ExUI8HLy50ZFd5s0Xk8IqqekwGlwzDoKR0Va83pxX400xUwJ6OI3'
  };